export default __webpack_public_path__ + "static/media/jenny-roderick-untermyergarden-palma-wedding-75.fd4af2a4.jpg";